import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import * as XLSX from 'xlsx';
import { importMoqsDiscount } from '@/api/moqs';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.fileExcelToJsonProgressing = false;
    this.processingMoqs = false;
    this.postForm = {
      file: null
    };
    this.excelData = [];
    this.showWarningDialog = false;
    this.showPreview = false;
    this.requiredColumns = ['moqId', 'dealersRoleId', 'dealersRole', 'rangeId', 'rangeName', 'productId', 'productName', 'productsVariationId', 'variationName', 'minimumCartonQuantity', 'discount'];
    this.optionalColumns = ['minimumQuantity'];
  }
  cancelWarning() {
    this.showWarningDialog = false;
  }
  proceedWithUpload() {
    this.showWarningDialog = false;
    // Trigger the hidden file input
    this.$nextTick(() => {
      const uploadComponent = this.$refs.uploadRef;
      const fileInput = uploadComponent.$el.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.click();
      }
    });
  }
  handleChange(file, fileList) {
    this.processFile(file);
  }
  processFile(file) {
    this.fileExcelToJsonProgressing = true;
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {
          type: 'array'
        });
        // Get the first sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        // Convert sheet to JSON (array of objects)
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: undefined,
          defval: null
        });
        // Validate the Excel structure
        if (!this.validateExcelStructure(jsonData)) {
          return;
        }
        this.excelData = jsonData;
        this.showPreview = true;
        console.log('Excel Data (Array of Objects):', this.excelData);
        console.log('Total Rows:', this.excelData.length);
        this.$message.success(`File validated successfully! ${this.excelData.length} rows ready for import.`);
      } catch (error) {
        console.error('Error reading Excel file:', error);
        this.$message.error('Error reading Excel file. Please try again.');
      } finally {
        this.fileExcelToJsonProgressing = false;
      }
    };
    reader.onerror = () => {
      this.$message.error('Error reading file.');
      this.fileExcelToJsonProgressing = false;
    };
    reader.readAsArrayBuffer(file.raw);
  }
  validateExcelStructure(data) {
    if (data.length === 0) {
      this.$message.error('Excel file is empty!');
      this.fileExcelToJsonProgressing = false;
      return false;
    }
    // Check if all required columns exist
    const firstRow = data[0];
    const actualColumns = Object.keys(firstRow);
    const missingColumns = this.requiredColumns.filter(col => !actualColumns.includes(col.trim()));
    if (missingColumns.length > 0) {
      this.$message.error(`Missing required columns: ${missingColumns.join(', ')}`);
      this.fileExcelToJsonProgressing = false;
      return false;
    }
    // Check for extra columns (excluding optional columns)
    const allAllowedColumns = [...this.requiredColumns, ...this.optionalColumns];
    const extraColumns = actualColumns.filter(col => !allAllowedColumns.includes(col.trim()));
    if (extraColumns.length > 0) {
      this.$message.warning(`Excel contains extra columns that will be ignored: ${extraColumns.join(', ')}`);
    }
    // Validate moqId column has values
    const rowsWithoutMoqId = data.filter(row => !row.moqId || row.moqId === null);
    if (rowsWithoutMoqId.length > 0) {
      this.$message.error(`Found ${rowsWithoutMoqId.length} row(s) without moqId. All rows must have a valid moqId.`);
      this.fileExcelToJsonProgressing = false;
      return false;
    }
    return true;
  }
  async handleImport() {
    this.$confirm('This action cannot be reversed. Do you want to proceed with the import?', 'Confirm Import', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      type: 'warning'
    }).then(async () => {
      this.processingMoqs = true;
      try {
        // Send data to backend
        const response = await importMoqsDiscount(this.excelData);
        console.log('Backend Response:', response.message);
        // Handle successful import
        this.$message.success(`Data imported successfully! ${this.excelData.length} rows processed.`);
        // Optionally emit an event or refresh parent data
        this.$emit('import-success', response.message);
        this.resetImport();
      } catch (error) {
        console.error('Error importing data:', error);
      } finally {
        this.processingMoqs = false;
      }
    }).catch(() => {
      this.$message.info('Import cancelled');
    });
  }
  cancelImport() {
    this.resetImport();
    this.$message.info('Import cancelled');
  }
  resetImport() {
    this.showPreview = false;
    this.excelData = [];
    this.postForm.file = null;
    // Clear the file input
    const uploadComponent = this.$refs.uploadRef;
    if (uploadComponent) {
      uploadComponent.clearFiles();
    }
  }
  handleRemove(file, fileList) {
    this.resetImport();
    console.log('File removed. Data cleared.');
  }
  handleExceed(files, fileList) {
    this.$message.warning('Only one file can be uploaded at a time.');
  }
};
default_1 = __decorate([Component({
  name: 'PolicyImport',
  components: {}
})], default_1);
export default default_1;